var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page-container" },
    [
      _c(
        "a-page-header",
        { staticClass: "page-header", on: { back: _vm.back } },
        [
          _c(
            "div",
            {
              staticStyle: { cursor: "pointer" },
              attrs: { slot: "title" },
              on: { click: _vm.back },
              slot: "title",
            },
            [
              _vm._v("\n      返回\n      "),
              _c("span", [_vm._v("工作台/")]),
              _c("span", { staticClass: "header-title" }, [_vm._v("心理辅导")]),
            ]
          ),
        ]
      ),
      _c(
        "TableList",
        {
          staticStyle: { "min-height": "80vh" },
          attrs: {
            columns: _vm.tabPaneConfig[0].columns,
            tableData: _vm.tabPaneConfig[0].tableData,
            loading: _vm.tabPaneConfig[0].loading,
            scroll: { x: true },
            pagination: _vm.tabPaneConfig[0].pagination,
          },
          on: { change: _vm.handleTableChange },
          scopedSlots: _vm._u([
            {
              key: "psychologyIssues",
              fn: function ({ record }) {
                return _c("div", {}, [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.getDictCodeData(
                          "emotional_type",
                          record.psychologyIssues
                        ).text
                      ) +
                      "\n    "
                  ),
                ])
              },
            },
            {
              key: "tutoringType",
              fn: function ({ record }) {
                return _c("div", {}, [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.getDictCodeData(
                          "tutoring_type",
                          record.tutoringType
                        ).text
                      ) +
                      "\n    "
                  ),
                ])
              },
            },
            {
              key: "remark",
              fn: function ({ record }) {
                return _c(
                  "div",
                  {},
                  [
                    _c(
                      "a-tooltip",
                      [
                        _c("template", { slot: "title" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(record.remark) +
                              "\n        "
                          ),
                        ]),
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              record.remark.length > 20
                                ? record.remark.substring(0, 20) + "..."
                                : record.remark
                            ) +
                            "\n      "
                        ),
                      ],
                      2
                    ),
                  ],
                  1
                )
              },
            },
            {
              key: "action",
              fn: function ({ record }) {
                return [
                  _c(
                    "div",
                    { staticClass: "action-detail" },
                    [
                      _c(
                        "span",
                        {
                          style: {
                            color:
                              record?.warnStatus == 5 ? "#0077fa" : "#9FCCF6",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.reported(record)
                            },
                          },
                        },
                        [_vm._v("\n          上报\n        ")]
                      ),
                      _c("a-divider", { attrs: { type: "vertical" } }),
                      _c(
                        "span",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.homeSchoolCom(record)
                            },
                          },
                        },
                        [_vm._v("家校沟通")]
                      ),
                      _c("a-divider", { attrs: { type: "vertical" } }),
                      _c(
                        "span",
                        {
                          style: {
                            color:
                              record?.warnStatus == 3 || record?.warnStatus == 4
                                ? "#0077fa"
                                : "#9FCCF6",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.mentoringRecord(record)
                            },
                          },
                        },
                        [_vm._v("\n          辅导记录\n        ")]
                      ),
                      _c("a-divider", { attrs: { type: "vertical" } }),
                      record?.warnStatus == 2
                        ? _c(
                            "a-popconfirm",
                            {
                              attrs: { title: "是否确认预约" },
                              on: {
                                confirm: function ($event) {
                                  return _vm.confirmReservation(record)
                                },
                                cancel: () => {},
                              },
                            },
                            [
                              _c(
                                "span",
                                { staticStyle: { color: "#0077fa" } },
                                [_vm._v("确认预约")]
                              ),
                            ]
                          )
                        : _c("span", { staticStyle: { color: "#9fccf6" } }, [
                            _vm._v("确认预约"),
                          ]),
                      _c("a-divider", { attrs: { type: "vertical" } }),
                      _c(
                        "span",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.viewArchives(record)
                            },
                          },
                        },
                        [_vm._v("查看档案")]
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "div",
            {
              staticStyle: { "margin-bottom": "20px" },
              attrs: { slot: "queryArea" },
              slot: "queryArea",
            },
            [
              _c("a-input-search", {
                staticStyle: { width: "170px", "margin-right": "15px" },
                attrs: { placeholder: "请输入学生名称" },
                on: { change: _vm.searchName },
                model: {
                  value: _vm.queryParam.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryParam, "name", $$v)
                  },
                  expression: "queryParam.name",
                },
              }),
              _c(
                "a-button",
                { attrs: { type: "primary" }, on: { click: _vm.queryTable } },
                [_vm._v("查询")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("ReportModal", {
        ref: "reportModalRef",
        on: { refreshData: _vm.loadData },
      }),
      _c("SchoolHomeComModal", { ref: "schoolHomeComModalRef" }),
      _c("MentoringRecordModal", {
        ref: "mentoringRecordModalRef",
        on: { refreshData: _vm.loadData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }